'use client'
import styles from './style.module.scss'
import { Flex } from 'antd'
import RightWarp from './RightWarp'
import Menu from './Menu'
import cls from 'classnames'
import { HCNextLink } from '../HCNextLink'
import { useAppSetting } from '../appStore'
import { usePathname } from 'next/navigation'
import ModeSwitch from './ModeSwitch'
import Logo from './Logo'

export default function Header() {
  const theme = useAppSetting('theme')
  const pathname = usePathname()
  // 检查除了第一个路径段以外,是否只有语言代码
  const isHomePage = pathname?.split('/').filter(Boolean).length === 1
  return (
    <div className={cls([styles.header, 'header', isHomePage && styles.homePage])}>
      <Flex align="center" justify="space-between" className="h-full">
        <Flex align="center">
          <Logo path="/" />
          <ModeSwitch active="exchange" />
        </Flex>
        <Flex flex={1} className="show-pc">
          <Menu />
        </Flex>
        <RightWarp />
      </Flex>
    </div>
  )
}
